<template>
    <div id="loading" class="p-5">
        <h1>Loading ...</h1>
    </div>
</template>


<script>
export default {
    name: 'Error'
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

#loading {
    background-color: $color-green;
    display: block;
    height: 100%;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 9998;
}
</style>
